import React from 'react';
import { SetComponentLanguage } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const StateOptions = () => {
    return (
        strings.states.map((state, i) => <option key={i} value={state.abbreviation}>{state.name}</option>)
    )
}
 
export default StateOptions;


// WEBPACK FOOTER //
// ./src/components/Common/StateOptions/StateOptions.js